import React, { useEffect, useRef } from 'react';
const WIDGET_CONFIG = {
  allow_symbol_change: true,
  calendar: false,
  details: false,
  hide_side_toolbar: false,
  hide_top_toolbar: false,
  hide_legend: false,
  hide_volume: true,
  hotlist: false,
  interval: '15',
  locale: 'en',
  save_image: true,
  style: '1',
  symbol: 'OANDA:XAUUSD',
  theme: 'light',
  timezone: 'America/New_York',
  backgroundColor: '#ffffff',
  gridColor: 'rgba(46, 46, 46, 0.2)',
  watchlist: ['OANDA:XAUUSD', 'BITSTAMP:BTCUSD', 'CAPITALCOM:NAS100', 'CAPITALCOM:SPX500'],
  withdateranges: true,
  compareSymbols: [],
  studies: ['STD;Trading%1Sessions'],
  autosize: true
};
export function TradingViewChart() {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
    script.async = true;
    script.innerHTML = JSON.stringify(WIDGET_CONFIG);
    container.appendChild(script);
    return () => {
      container.innerHTML = '';
    };
  }, []);
  return <div ref={containerRef} className="tradingview-widget-container" style={{
    height: '100%',
    width: '100%'
  }} data-id="element-5" data-mp="2qmq12bw1wdbd">
      <div className="tradingview-widget-container__widget" style={{
      height: 'calc(100% - 32px)',
      width: '100%'
    }} data-id="element-6" data-mp="2ur6507m3tany" />
      <div className="tradingview-widget-copyright" data-id="element-7" data-mp="2lowydstyi1fu">
        <a href="https://www.tradingview.com/symbols/XAUUSD/?exchange=OANDA" rel="noopener nofollow" target="_blank" data-id="element-8" data-mp="2lqhqlbsst8aj">
          <span className="blue-text" data-id="element-9" data-mp="2bzn3y6bn46ok">XAUUSD chart</span>
        </a>
        <span className="trademark" data-id="element-10" data-mp="1xz2kr91tc8uj"> by TradingView</span>
      </div>
    </div>;
}